import React, { useEffect, useState, useContext, useRef } from 'react';
import {IProps, IState, IFolder} from './types';
import { IDesign } from "@state/designs/types";
import MasterPage from '@components/MasterPage';
import Header from '@routes/private/MyDesigns/components/Header';
import DesignsList from '@routes/private/MyDesigns/components/DesignsList';
import WarningScreen from '@components/WarningScreen';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import * as S from './styles';
import Folders from './components/Folders';
import { useSelector, useDispatch } from 'react-redux';
import actions from '@state/actions';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import selectors from '@state/selectors';
import { PermissionEnum } from '@state/designs/types';

const SharedFiles:React.FC<IProps> = (props, state: IState) => {

  const authContext = useContext(AuthContext);
  const{ filters, allFilters , getFilterQuery, getQuerySearch, sortByQuery, searchSelectedOne, searchSelectedAll, setSharedFiles, fetchCounter, setSearching, setSearchValue, sharedFiles } = useContext(DesignsContext);

  const [isLoading, setIsLoading] = useState(true);
  const [folders, setFolders] = useState<IFolder[]>([
    {
      id: '1',
      name: 'Edit Access', 
      counter: undefined,
      value: PermissionEnum.EDIT
    },
    {
      id: '2',
      name: 'View Only Access', 
      counter: undefined,
      value: PermissionEnum.VIEW
    }
  ]);
  const [selectedFolder, setSelectedFolder] = useState<number>(0);
  const [currentDesigns, setCurrentDesigns] = useState(state.currentDesigns);
  const [globalDesigns, setGlobalDesigns] = useState(state.globalDesigns);
  const [hasMore, setHasmore] = useState([true, true]);
  const [start, setStart] = useState(0);
  const [open, setOpen] = useState(false);

  const counter = useSelector(selectors.designs.getCounterSharedFiles);

  const [warningOptions, setWarningOptions] = useState({
    title: '',
    subtitle: '',
    actionTitle: '',
    actionFunction: () => {},
    closeActionTitle: '',
    errorNote: '',
    errorArguments: [],
  });

  const pagelength: number = 20;

  const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
    setOpen(openValue);
    setWarningOptions({
      title: title,
      subtitle: subtitle,
      actionTitle: actionTitle,
      actionFunction: actionFunction,
      closeActionTitle: closeActionTitle,
      errorNote: errorNote,
      errorArguments: errorArguments,
    })
  }

  const dispatch = useDispatch();

  const fetchCounters = () => {
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchDesignCounters(userData.email, true, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const fetchDesigns = (permission: number, length: number) => {  
    const query = createQuery(permission, length);
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.fetchDesigns(query, (result, error) => {
        if (error) reject(error)
        else resolve(result)
      }))
    });
  }

  const createQuery=(permission: number, length: number)=>{
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };

    let status = `c.designStatus='ACTIVE'`;
    let filters =  encodeURIComponent(getFilterQuery());
    let search = encodeURIComponent(getQuerySearch());
    let orderBy = sortByQuery!=='' ? `orderby=${sortByQuery}` : 'orderby=c.updateDate DESC';
    var permissions = `and ARRAY_CONTAINS(c.usersPermission, {"email": "${userData.email}", "permission": ${permission}})`

    return `?filter= ${status} ${filters} ${search} ${permissions}&${orderBy}&start=${length}&pagelength=${pagelength}`;
  }

  const reloadDesigns = async (folder: number, reload?: boolean, loadMore?: boolean) => {
      try {
        if (!loadMore) setIsLoading(true);
        var newGlobalDesigns: IDesign[][] = reload ? Array(2).fill([]) : globalDesigns??Array(2).fill([]);
        let newhasMore = reload ? [true, true] : [...hasMore]; 
        let start: number = loadMore ? globalDesigns[folder].length : 0;
        const designsResult: any = await fetchDesigns(folders[folder]?.value??PermissionEnum.EDIT, start);
        let index =  folders[folder]?.value===1 ? 0: 1;
        newGlobalDesigns[index] = [...newGlobalDesigns[index], ...designsResult];
        setCurrentDesigns(newGlobalDesigns[index]);
        setGlobalDesigns(newGlobalDesigns);
        setIsLoading(false);
        if (designsResult?.length < pagelength) newhasMore[folder] = false;
        setHasmore(newhasMore);
      }
      catch(error) {
        console.error(error);
      }
  }

  useEffect(() => {
    const run = async () => {
      await fetchCounters();
    }
    run();
  }, []);

  useEffect(() => {
    if (counter?.length>0) {
      let foldersList : IFolder[] = [...folders]
      counter.forEach((element: any, index: number) => {
        if (foldersList[index] && element.counter) foldersList[index].counter = element.counter;
      });
      setFolders(foldersList);
    }
  }, [counter]);

  useEffect(() => {
    if (folders.length> 0) setSharedFiles({open: true, permission: folders[selectedFolder]?.value??PermissionEnum.EDIT});
    if (allFilters?.length>0) loadCounterSearch();
  }, [selectedFolder, folders]);

  useEffect(() => {
    if (!searchSelectedOne && !searchSelectedAll) reloadDesigns(selectedFolder, true);
    if (searchSelectedAll && filters ) {
      reloadDesigns(selectedFolder, true);
      loadCounterSearch();
    }
  }, [filters , sortByQuery, searchSelectedAll,searchSelectedOne ])

  useEffect(() => {
    if (allFilters?.length>0) loadCounterSearch();
  }, [allFilters]);

  const handleSelectFolder = (index: number) => {
    setIsLoading(true);
    setTimeout(() => { setIsLoading(false);}, 600)
    setSelectedFolder(index);
    if (globalDesigns && globalDesigns[index]?.length===0 && hasMore[index]) {
      if (searchSelectedOne || searchSelectedAll) {
        setSearching(false);
        setSearchValue('');
      } else reloadDesigns(index);
    } else if (globalDesigns && globalDesigns[index]) {
      setCurrentDesigns(globalDesigns[index]);
    }
  }

  const handleLoadMore = () => {
    if (hasMore[selectedFolder]) reloadDesigns(selectedFolder, false, true);
  }

  const loadCounterSearch = async() => {
    if (folders[selectedFolder].value!==undefined) {
      fetchCounter(folders[selectedFolder].value);
    }
  }

  useEffect(() => {
    if (searchSelectedOne) setCurrentDesigns([searchSelectedOne]);
  }, [searchSelectedOne])

  useEffect(() => {
    if (searchSelectedAll) {
      reloadDesigns(selectedFolder, true);
      loadCounterSearch();
    }
  }, [searchSelectedAll])

  useEffect(() => {
    if (searchSelectedAll && sharedFiles?.open) loadCounterSearch();
  }, [sharedFiles])

  const duplicateDesign = (id: string) => {
    return new Promise((resolve, reject) => {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      dispatch(actions.designs.duplicateDesign({id: id,userData: userData}, (result: any, error: any) => {
        if (error) {
          reject(error);
        }
        else {
          resolve(result);
        }
      }))
    })
  }
  
  const updateDesign = (design: any, action: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesign(design, action, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const handleUpdateDesignDelete = (design: any, action: string) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.designs.updateDesigndelete(design, action, true, (result: any, error: any) => {
        if (error) {
          reject(error);
        } else {
          resolve(result);
        }
      }))
    })
  }

  const handleDuplicate = async (item: any) => {
    try {
      item.usersPermission = [];
      const designDuplicated:any = await duplicateDesign(item.id);
      window.open(`/editor/design/${designDuplicated.id}`);
    } catch (error) {
      handleWarningScreen(
        true, "Create a Copy & Edit",
        `The design was not duplicated, please try later.`,
        "", undefined, "OKAY", "Duplicate design process failure",[]
      );
      console.error(error);
    }
  }

  const handleFavorite = async (item: any) => {
    item.favorite = item.favorite ? false : true;
    try {
      var updatedDesign: any = await updateDesign(item, 'FAVORITES');
      if (updatedDesign.status === 200 ) reloadDesigns(selectedFolder, true);
    } catch(error) {
      console.error(error);
    }
  }

  const handleDelete = async (item: IDesign) => {
    item.designStatus = 'INACTIVE';
    const userData = {
      email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
      name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
    };
    item.updatedBy = userData;
    try {
      handleWarningScreen(
        true, "Delete Design",
        `If you delete this design you will not be able to access it again.`,
        "", () => {return false;}, "DELETING...", "", []
      );
      var updatedDesign: any = await handleUpdateDesignDelete(item, 'DELETE');
      if (updatedDesign.status === 200) {
        handleWarningScreen(
          true, "Delete Design",
          `The design was deleted successfully.`,
          "", () => {
            reloadDesigns(selectedFolder, true);
            const run = async () => {
              await fetchCounters();
            }
            run();
          }, "OKAY", "", []
        );
      } else {
        throw new Error;
      }
    } catch(e) {
      handleWarningScreen(
          true, "Delete Design",
          `The design was not deleted, please try later...`,
          "", undefined, "OKAY", "Delete design process failure", []
      );
    }
  }

  const handleAskDelete = (item: any) => {
    handleWarningScreen(
      true, "Delete Design",
      `If you delete this design you will not be able to access it again.`,
      "CANCEL", () => {handleDelete(item)}, "DELETE", "", []
    );
  }

  const onActions = (item: any, action: string, folder?:number) => {
    if (item.id) {
      if (action === "DUPLICATEEDIT") handleDuplicate(item);
      if (action === "FAVORITEDESIGN") handleFavorite(item);
      if (action === "DELETE") handleAskDelete(item);
    }
  }

  

  return ( 
    <S.Root>
      <WarningScreen
        open={open}
        setOpen={setOpen}
        options={warningOptions}
      />
      <MasterPage
        pageIndex={5}
        newHeight={300}
      >
        <S.AbsoluteContentContainer>
          <Header hideFoldersSearch={true}/>
          <S.ContentContainer>
              <Folders
              folders={folders}
              selectedFolder={folders[selectedFolder]??{}}
              selectFolder={( index:number ) => handleSelectFolder(index)}
              hasMore={hasMore}
              onActions={() =>{}}
              finishDeleteFolder={false}
            />
            <DndProvider backend={HTML5Backend}>
            <DesignsList
                isLoading={isLoading}
                hasNoDesigns={((folders?.length && folders[0].counter && folders[0].counter > 0) || currentDesigns?.length>0) ? false : true}
                currentDesigns={currentDesigns}
                hasMore={hasMore[selectedFolder]??false}
                loadMoreDesigns={() => handleLoadMore()}
                onActions={(item: any, action: string, folder?:number) => onActions(item, action, folder)}
                selectedFolder={""}
                handleWarningScreen={handleWarningScreen}
                blockSelection={true}
              />
              </DndProvider>
          </S.ContentContainer>
        </S.AbsoluteContentContainer>
      </MasterPage>
    </S.Root>
  );
}

export default SharedFiles;